export default {
	system_functions: []
};
